import { Injectable, WritableSignal, inject } from '@angular/core';
import {MessageService} from "primeng/api";
import StackTrace, { StackFrame } from "stacktrace-js";
import {ProgressService} from "./progress.service";
import {GatherDebugData} from "./gather-debug-data";
import {Log4TSProvider} from "typescript-logging-log4ts-style";
import {LogLevel} from "typescript-logging";

@Injectable({
    providedIn: "root"
})
export class ErrorService {
    private progressService = inject(ProgressService);
    private messageService = inject(MessageService);


    private registeredServices: Map<string, GatherDebugData> = new Map<string, GatherDebugData>();

    private readonly LOG = LogProvider.getLogger('ErrorService');

    async handleError(param: {
        severity: string;
        summary: string;
        stack: any;
        detail: string;
        error?: any;
        ancillaries?: any[]
    }) {
        // console.log('LOGIN ERROR:', param);
        if (!param.stack) {
            param.stack = await StackTrace.get({
                sourceCache: {}
            });
        }
        this.messageService.add({
            severity: param.severity,
            summary: param.summary,
            detail: param.detail
        });
        // TODO: Send a bug report if configured to do so
        this.LOG.debug(param.detail, param.error, param.ancillaries, param.stack);
        this.gatherDebug();
    }

    registerServiceForDebug(name: string, gatherFunction: GatherDebugData) {
        this.registeredServices.set(name, gatherFunction);
    }

    gatherDebug() {
        this.progressService.blockWithMessage('Error Detected: Gathering Debug Information');
        let out = {};
        for (const key of this.registeredServices.keys()) {
            if (this.registeredServices.get(key)) {
                out[key] = this.registeredServices.get(key).getDebugInfo();
            }
        }
        this.LOG.debug('DEBUG: ',out);
        this.progressService.unBlock();
        return out;
    }
}

export const LogProvider = Log4TSProvider.createProvider("RNGLogging", {
    level: LogLevel.Debug,
    groups: [{
        identifier: "matchAll",
        expression: new RegExp(".+"),
    }],
    channel: {
        type: "RawLogChannel",
        write: ((msg, formatArg) => {
            window.console.log('LOCAL: ', msg);
        })
    }
});

export function activateSignalDebugger<Type>(s: WritableSignal<Type>, name: string) {
    const srcSet = s.set; // we need the source method to avoid recursion
    const LOG = LogProvider.getLogger('DebuggableWritableSignal');

    const debug: boolean = true; //Later, this can check and not wrap if off

    if (debug) {
        s.set = async (value: Type) => {
            const err = new Error('STACK GENERATOR');
            console.log('SD: '+name,err);
            const stack = await StackTrace.get();
            LOG.debug(name+' [SET] value: ', value, stack);
            srcSet(value);
        };
        s.update = async (updateFn: (value: Type) => Type) => {
            const value = updateFn(s());
            const stack = await StackTrace.get();
            LOG.debug(name+' [UPDATE] value: ', value, stack);
            srcSet(value);
        };
    }
}
